module.exports = __webpack_public_path__ + "img/verified.2a64665e.svg";